import classNames from 'classnames';
import type { FC } from 'react';
import React, { useMemo } from 'react';

import { COUNTRY_PHONE_PREFIXES, DEFAULT_DELIVERY_COUNTRY } from '../../utils/constants';
import { isValidPhone } from '../../utils/validate';

import './Input.scss';
import './PhoneInput.scss';

interface IPhoneInputProps {
  label?: string;
  name?: string;
  value?: string;
  country?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  showError?: boolean;
  wrapperClass?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const PhoneInput: FC<IPhoneInputProps> = ({
  label,
  name,
  value = '',
  country,
  placeholder = '',
  required = false,
  disabled = false,
  showError = false,
  wrapperClass,
  onChange
}) => {
  const prefix = useMemo(() => {
    const countryToUse = country || DEFAULT_DELIVERY_COUNTRY;

    return COUNTRY_PHONE_PREFIXES[countryToUse] || '+49';
  }, [ country ]);

  const isInvalid = useMemo(() => {
    if (!showError) {
      return false;
    }
    if (required && !value) {
      return true;
    }
    if (value && !isValidPhone(value, country)) {
      return true;
    }

    return false;
  }, [ showError, required, value, country ]);

  return (
    <div className={classNames('styled-input phone-input-wrapper', wrapperClass, {
      'has-error': isInvalid
    })}>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="phone-input-container">
        <span className="phone-prefix">{prefix}</span>
        <input
          id={name}
          type="tel"
          value={value}
          name={name}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
          className="phone-input"
        />
      </div>
    </div>
  );
};

export default PhoneInput;
